import { orderReference } from './orderReference';
import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { getShipmentById, getUserById } from '../../api/endpoints/admin';
import { getOrderMoneySummary, mapPaymentError } from '../../api/endpoints/payments';
import { SettlementStatement } from './SettlementStatement';
import { PrintToolbar } from './PrintToolbar';
export function SettlementPrintView() {
  const { t } = useTranslation();
  const id = Number(useParams().id);
  const result = useQuery({
    queryKey: ['payments', 'settlement', id],
    enabled: Number.isSafeInteger(id) && id > 0,
    retry: false,
    queryFn: async () => {
      const [summary, shipment] = await Promise.all([
        getOrderMoneySummary(id),
        getShipmentById(id),
      ]);
      const partner = shipment.fleetManagerId ? await getUserById(shipment.fleetManagerId) : null;
      return {
        summary,
        vehicleNumber: shipment.assignment?.vehicleRegistrationNumber,
        partnerGstin: typeof partner?.profile?.gstin === 'string' ? partner.profile.gstin : null,
        partnerPan:
          typeof partner?.profile?.panNumber === 'string' ? partner.profile.panNumber : null,
      };
    },
  });
  if (!Number.isSafeInteger(id) || id <= 0)
    return <p role="alert">{t('invoices.settlementPrintView.invalidId')}</p>;
  if (result.isPending) return <p role="status">{t('invoices.settlementPrintView.loading')}</p>;
  if (result.isError)
    return (
      <p role="alert">
        {mapPaymentError(result.error)}{' '}
        <button onClick={() => result.refetch()}>{t('common.actions.retry')}</button>
      </p>
    );
  return (
    <main className="dnm-print-page">
      <PrintToolbar
        title={`Settlement · ${orderReference(result.data.summary.shipmentId)} · DNM Logistics`}
      />
      <SettlementStatement {...result.data} />
    </main>
  );
}
